import { useEffect } from 'react';
import {
  useStoreActions,
  useStoreRehydrated,
  useStoreState,
} from '@discover-data/stores/restaurant/hooks';
import useTagIdsQueryState from './useQueryState';
import selectionKey from './selectionKey';

/**
 * Sync the router state value to the restaurant store
 */
export default function useSyncTagIds(
  tags: {
    category: string | null;
    title: string | null;
    id: number | null;
  }[]
) {
  const rehydrated = useStoreRehydrated();
  const storeValues = useStoreState((state) => state.tagIds.value);
  const setStoreValues = useStoreActions((actions) => actions.tagIds.set);
  const [routerValues] = useTagIdsQueryState(tags);

  const routerSelectionKey = selectionKey(routerValues);

  useEffect(() => {
    if (!rehydrated) {
      return;
    }

    // URL order can differ from click order without changing the selected filters.
    if (routerSelectionKey !== selectionKey(storeValues)) {
      setStoreValues(routerValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rehydrated, routerSelectionKey]);
}
